import { render } from "./SlDownloads.vue?vue&type=template&id=393c02f4&scoped=true"
import script from "./SlDownloads.vue?vue&type=script&lang=js"
export * from "./SlDownloads.vue?vue&type=script&lang=js"

import "./SlDownloads.vue?vue&type=style&index=0&id=393c02f4&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393c02f4"]])

export default __exports__